import React, { useState } from "react";
import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";

import {
  CriticalPathManagementSearchCriteria,
  PageListBean,
  RestCriticalPathManagementListRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyString } from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { AppContext } from "../AppContext.js";
import { CPMRestService } from "../services/CPMRestService.js";
export class CpmLookupHandler extends LookupHandler {
  static contextType = AppContext;
  constructor(companyCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let resetCriteria = new CriticalPathManagementSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new CriticalPathManagementSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let rawMaterialLookupCriteria =
      new CriticalPathManagementSearchCriteria();
    rawMaterialLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = CpmLookupCriteraHandler(
      companyCode,
      rawMaterialLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      rawMaterialLookupCriteria,
      lookupCriteriaView
    );
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition("Template", "templateCode", 0, false);
    this.addColumnDefinition("Customer ", "customerCode", 0, false); //2
    this.addColumnDefinition("CPMStatus ", "cpmStatus", 0, false); //3
    
  }
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      if (!isEmptyString(filterText)) {
        search.rawMaterialCodeContains = filterText;
        this.searchCriteria =
          new CriticalPathManagementSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadRawMaterialList(lookup_dialog, pageNumber, search);
    }
  }
  loadRawMaterialList = (lookup_dialog, pageNumber, searchCriteria) => {
    let criteria = new CriticalPathManagementSearchCriteria(); //To be fetched from CriteriaHandler
    criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      criteria.cpmCode = searchCriteria.cpmCode;
    //  criteria.rawMaterialName = searchCriteria.rawMaterialName;
      criteria.cpmNameContains = searchCriteria.cpmNameContains;
      criteria.rawMaterialNameContains = searchCriteria.rawMaterialNameContains;
      criteria.cpmNameStartsWith =
        searchCriteria.cpmNameStartsWith;
      // criteria.productType = searchCriteria.productType;
      // criteria.wareHouseCode = searchCriteria.wareHouseCode;
      // criteria.inventoryUOMCode = searchCriteria.inventoryUOMCode;
    }
    let pageList = new PageListBean();
    pageList.pageSize = 50; //TODO --> Fetch from Config
    pageList.currentPage = pageNumber;
    pageList.pageNumber = pageNumber;
    let requestInput = new RestCriticalPathManagementListRequest();
    requestInput.pageInput = pageList;
    requestInput.criteria = criteria;
    CPMRestService.getCriticalPathManagementPageList(
      requestInput,
      (response) => this.loadListResponse(response, lookup_dialog),
      this.loadListError
    );
  };
  loadListResponse = (response, lookup_dialog) => {
    let rawMaterialList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.cpmPageList != null &&
      response.data.cpmPageList
        .cpmBean !== null
    ) {
      rawMaterialList =
        response.data.cpmPageList
          .cpmBean;
      totalCount =
        response.data.cpmPageList.totalCount;
      currentPageNumber =
        response.data.cpmPageList.currentPage;
      pageSize = response.data.cpmPageList.pageSize;
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = rawMaterialList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadListError = (error) => {
    ShowError("Error : " + error);
  };
}
const CpmLookupCriteraHandler = (companyCode, rawMaterialLookupCriteria) => {
  return class extends React.Component {
    static contextType = AppContext;
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new CriticalPathManagementSearchCriteria(),
        countUOMs: [],
        productTypes: [],
        showAutoCompleteUOMList: true,
        uomPageListForAutoCompleteList: new Array(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      const { appData } = this.context;
      const { cache } = appData;
      this.cache = cache;
      if (this.focusRef.current) this.focusRef.current.focus();
      this.loadCacheDetails();
      this.initLookupHandlers();
    }

    loadCacheDetails = () => {
      // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
      const attribute_cache = { ...this.cache };
      let countUOMs = this.state.countUOMs;

      if (attribute_cache.uoms != null) {
        attribute_cache.uoms.map((line) => {
          countUOMs.push(line);
          // }
        });
      }

      this.setState({
        countUOMs: countUOMs,
      });
    };
    initLookupHandlers = () => {
      let uomsLookupHandler = new GenericAttributeLookupHandler(
        this.state.countUOMs,
        "UOM"
      );
      this.setState({ uomsLookupHandler: uomsLookupHandler });
    };
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      this.setState({
        searchCriteria: new CriticalPathManagementSearchCriteria(),
      });
    };

    // onUOMCodeChange = (e) => {
    //   let inventoryUOMCode = e.target.value;
    //   this.state.showAutoCompleteUOMList = true;
    //   let temp_searchCriteria = this.state.searchCriteria;
    //   let showAutoCompleteList = this.state.showAutoCompleteUOMList;
    //   if (isEmpty(inventoryUOMCode)) {
    //     this.state.showAutoCompleteUOMList = false;
    //     let showAutoCompleteList = this.state.showAutoCompleteUOMList;
    //     let searchCriteria = this.state.searchCriteria;
    //     searchCriteria.inventoryUOMCode = "";
    //     let suggestion = [];
    //     this.setState({
    //       showAutoCompleteList: showAutoCompleteList,
    //       searchCriteria: searchCriteria,
    //       uomPageListForAutoCompleteList: suggestion,
    //     });
    //   } else if (showAutoCompleteList === true && inventoryUOMCode !== "") {
    //     this.readUomCodeBySearchString(inventoryUOMCode);
    //   }
    //   if (e.target.name == "inventoryUOMCode") {
    //     temp_searchCriteria["inventoryUOMCode"] = e.target.value;
    //     let uom_List = this.state.countUOMs;
    //     uom_List.map((line) => {
    //       if (line.code == e.target.value) {
    //         temp_searchCriteria["inventoryUOMCode"] = line.code;
    //         this.state.showAutoCompleteUOMList = false;
    //         let showAutoCompleteList = this.state.showAutoCompleteUOMList;
    //         this.setState({ showAutoCompleteList: showAutoCompleteList });
    //       }
    //     });
    //   }
    //   this.setState({ searchCriteria: temp_searchCriteria });
    // };
    // readUomCodeBySearchString(searchString) {
    //   let uomCodeData = this.state.countUOMs;
    //   let simpleAutoCompleteList = new Array();
    //   if (uomCodeData.length > 0 && uomCodeData != null) {
    //     uomCodeData.map((uomCodeDatas) => {
    //       let simpleItemBean = {
    //         code: uomCodeDatas.code,
    //         description: uomCodeDatas.description,
    //       };
    //       simpleAutoCompleteList.push(simpleItemBean);
    //     });
    //   }
    //   let userInput = searchString;
    //   let filteredSuggestions = new Array();
    //   filteredSuggestions = simpleAutoCompleteList.filter(
    //     (simpleAutoCompleteUomCodeLists) =>
    //       simpleAutoCompleteUomCodeLists.code
    //         .toLowerCase()
    //         .indexOf(userInput.toLowerCase()) > -1
    //   );
    //   this.setState({ uomPageListForAutoCompleteList: filteredSuggestions });
    // }
    // uomEnterKeyEvent = (e) => {
    //   let temp_searchCriteria = this.state.searchCriteria;
    //   let inventoryUOMCode = e.target.value;
    //   temp_searchCriteria["inventoryUOMCode"] = inventoryUOMCode;
    //   let productType_List = this.state.countUOMs;
    //   let inventoryUomCodeBean = null;
    //   productType_List.map((line) => {
    //     if (line.code == e.target.value) {
    //       inventoryUomCodeBean = line;
    //     }
    //   });
    //   if (!isEmpty(inventoryUomCodeBean)) {
    //     let temp_searchCriteria = this.state.searchCriteria;
    //     temp_searchCriteria.inventoryUOMCode = inventoryUomCodeBean.code;
    //     this.setState({
    //       searchCriteria: temp_searchCriteria,
    //       uomPageListForAutoCompleteList: new Array(),
    //     });
    //   }
    // };
    // displayAutoCompleteUomList = (showAutoCompleteList) => {
    //   this.setState({ showAutoCompleteUomList: showAutoCompleteList });
    // };

    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container>
            <Row>
              <Col sm={5}>
                <FormLabel>CPM Code</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  // tabIndex={-1}
                  id="cpmCode"
                  name="cpmCode"
                  onChange={this.onChange}
                  value={searchCriteria.cpmCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>CPM Code Starts With</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  // tabIndex={-1}
                  id="cpmNameStartsWith"
                  name="cpmNameStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.cpmNameStartsWith}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={5}>
                <FormLabel>CPM Code Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="cpmNameContains"
                  name="cpmNameContains"
                  onChange={this.onChange}
                  value={searchCriteria.cpmNameContains}
                />
              </Col>
            </Row>
            {/* <Row>
              <Col sm={5}>
                <FormLabel>CPM Type</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="wareHouseCode"
                  name="wareHouseCode"
                  onChange={this.onChange}
                  value={searchCriteria.wareHouseCode}
                />
              </Col>
            </Row> */}

            <Row className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
